import blindSpot from '../../../../../../../public/img/Blind Spot.svg'
import catylystImage from '../../../../../../../public/img/Catalyst.svg'
import treasureImage from '../../../../../../../public/img/Treasure.svg'
import vulnerabilityImage from '../../../../../../../public/img/Hurdle.svg'


export const TABLE_HEADINGS = [{ title: "Category", className: "" }, { title: "Behavior", className: "" },
{ title: "All But Self", className: "" }, { title: "Self", className: "" }
]

export const TABLE_HEADINGS_FOR_ARCTRYX = [{ title: "Category", className: "" }, { title: "Behavior", className: "" },
]

export const CLASSNAMES_BASED_ON_CARD = {
    knownStrength: "",
    unknownStrength: "gray",
    knownImprovementAreas: "gray",
    unknownImprovementAreas: ""
}

export const CARD_IMAGE = {
    knownStrength: catylystImage,
    unknownStrength: blindSpot,
    knownImprovementAreas:treasureImage ,
    unknownImprovementAreas: vulnerabilityImage
}